import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { FILL_RATE_BY_SPOT_LIST_CHART_DEFINITION } from './fill-rate-by-spot-list-chart.definition';
import { FILL_RATE_BY_SPOT_LIST_CHART_MOCK_DATA } from './fill-rate-by-spot-list-chart.mock';

export const FillRateBySpotListChart = (props: ListChartProps) => <ListChart {...props} />;

FillRateBySpotListChart.definition = FILL_RATE_BY_SPOT_LIST_CHART_DEFINITION;
FillRateBySpotListChart.mockData = FILL_RATE_BY_SPOT_LIST_CHART_MOCK_DATA;
